export const postTabs = [
  { menuItem: 'Wszystkie', value: '' },
  { menuItem: 'Nike', value: 'nike' },
  { menuItem: 'Jordan', value: 'jordan' },
  // { menuItem: 'Yeezy', value: 'yeezy' },
  { menuItem: 'Adidas', value: 'adidas' },
  { menuItem: 'Reebok', value: 'reebok' },
];
